module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Files/Music-645f00a00fc6315491a0ddd96d216b122f2a707d023fe8174f12503635b139ac.svg";